/**
 * Tiny dependency-free SVG sparkline. Renders a smoothed area+line chart of
 * numeric points. Zero-safe (won't blow up on empty data). Tooltips on hover.
 */
export default function Sparkline({
  data = [], width = 220, height = 44,
  stroke = "#2563EB", fill = "#2563EB22", ariaLabel = "sparkline",
  showZeroLine = true, testId = "sparkline",
}) {
  const values = data.map((d) => (typeof d === "number" ? d : d.count || 0));
  if (values.length < 2) {
    return (
      <svg width={width} height={height} data-testid={testId}
           className="text-muted-foreground/40">
        <line x1="0" y1={height / 2} x2={width} y2={height / 2}
              stroke="currentColor" strokeDasharray="2 3" strokeWidth="1" />
      </svg>
    );
  }
  const max = Math.max(1, ...values);
  const step = width / (values.length - 1);
  const points = values.map((v, i) => [i * step, height - 4 - (v / max) * (height - 8)]);
  const line = points.map((p, i) => `${i === 0 ? "M" : "L"} ${p[0].toFixed(1)} ${p[1].toFixed(1)}`).join(" ");
  const area = `${line} L ${width} ${height} L 0 ${height} Z`;
  return (
    <svg width={width} height={height} role="img" aria-label={ariaLabel} data-testid={testId}>
      {showZeroLine && (
        <line x1="0" y1={height - 4} x2={width} y2={height - 4}
              stroke="currentColor" strokeOpacity="0.15" strokeWidth="1" />
      )}
      <path d={area} fill={fill} />
      <path d={line} fill="none" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      {points.map(([x, y], i) => (
        <circle key={i} cx={x} cy={y} r={values[i] > 0 ? 2 : 1.4}
                fill={values[i] > 0 ? stroke : "#94a3b8"}
                data-testid={`${testId}-point-${i}`}>
          <title>{typeof data[i] === "object" ? `${data[i].date}: ${data[i].count}` : String(values[i])}</title>
        </circle>
      ))}
    </svg>
  );
}
